import { useNavigate, useParams } from 'react-router-dom'
import { EditSeatMetricDrawer } from './EditSeatMetricDrawer'

export const EditSeatMetricRoute = () => {
  const { metricId } = useParams<{ metricId: string }>()
  const navigate = useNavigate()

  if (!metricId) {
    navigate('/seats')
    return null
  }

  return (
    <EditSeatMetricDrawer
      seatMetricId={metricId}
      onClose={() => navigate('/seats')}
      onUpdate={() => navigate('/seats')}
    />
  )
}
